import config from '@/config';
import { LogicContext } from '@/logic/main/types';
import { getItemsWithNoJackpotCached } from '@/utils/jackpotsV2/getItemsWithNoJackpotCached';
import { getJackpotsV2ForGames } from '@/utils/jackpotsV2/getJackpotsV2ForGames';

export const getJackpotsV2ForSearchGames = async (context: LogicContext) => {
  if (config?.features?.jackpotsV2?.mode !== 'enabled') {
    return {};
  }
  const currentJackpotsV2 = context.currentJackpotsV2;
  const allGames = context.search.searchItems;
  const filteredGames = getItemsWithNoJackpotCached(
    allGames,
    currentJackpotsV2
  );
  const currency = context.user?.currency || config.default_currency;
  return getJackpotsV2ForGames(filteredGames, currency);
};
